import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, FileText, MessageSquare, AlertCircle, Clock } from 'lucide-react';
import { MOCK_ACTIVITIES } from '../../utils/mockData';
export function ActivityTimeline() {
  const getIcon = (type: string) => {
    switch (type) {
      case 'payment':
        return <CheckCircle className="h-5 w-5 text-green-500 dark:text-green-400" data-id="element-2211" />;
      case 'document':
        return <FileText className="h-5 w-5 text-blue-500 dark:text-blue-400" data-id="element-2212" />;
      case 'message':
        return <MessageSquare className="h-5 w-5 text-purple-500 dark:text-purple-400" data-id="element-2213" />;
      case 'alert':
        return <AlertCircle className="h-5 w-5 text-orange-500 dark:text-orange-400" data-id="element-2214" />;
      default:
        return <Clock className="h-5 w-5 text-gray-500 dark:text-gray-400" data-id="element-2215" />;
    }
  };
  return <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-6 transition-colors" data-id="element-2216">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 truncate" data-id="element-2217">
        Recent Activity
      </h3>
      <div className="flow-root" data-id="element-2218">
        <ul className="-mb-8" data-id="element-2219">
          {MOCK_ACTIVITIES.map((activity, activityIdx) => <motion.li key={activity.id} initial={{
          opacity: 0,
          x: -10
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: activityIdx * 0.1
        }} data-id="element-2220">
              <div className="relative pb-8" data-id="element-2221">
                {activityIdx !== MOCK_ACTIVITIES.length - 1 ? <span className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200 dark:bg-gray-700" aria-hidden="true" data-id="element-2222" /> : null}
                <div className="relative flex gap-3" data-id="element-2223">
                  <div className="h-8 w-8 rounded-full bg-gray-50 dark:bg-gray-700 flex items-center justify-center ring-8 ring-white dark:ring-gray-800 flex-shrink-0" data-id="element-2224">
                    {getIcon(activity.type)}
                  </div>
                  <div className="min-w-0 flex-1 pt-1.5 flex flex-col sm:flex-row justify-between gap-2" data-id="element-2225">
                    <div className="min-w-0 flex-1" data-id="element-2226">
                      <p className="text-sm text-gray-900 dark:text-white font-medium truncate" data-id="element-2227">
                        {activity.title}
                      </p>
                      <p className="text-sm text-gray-500 dark:text-gray-400 line-clamp-2" data-id="element-2228">
                        {activity.description}
                      </p>
                    </div>
                    <div className="text-left sm:text-right text-sm whitespace-nowrap text-gray-500 dark:text-gray-400 flex-shrink-0" data-id="element-2229">
                      <time dateTime={activity.timestamp} data-id="element-2230">
                        {activity.timestamp}
                      </time>
                    </div>
                  </div>
                </div>
              </div>
            </motion.li>)}
        </ul>
      </div>
      <div className="mt-6" data-id="element-2231">
        <button className="w-full flex justify-center items-center px-4 py-2 border border-gray-300 dark:border-gray-600 shadow-sm text-sm font-medium rounded-md text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors" data-id="element-2232">
          View all activity
        </button>
      </div>
    </div>;
}